import { twMerge } from 'tailwind-merge'
import CheckCheckboxIcon from '../icons/check-checkbox-icon'

export interface CheckboxProps {
  className?: string
  iconClassName?: string
  labelClassName?: string
  value: boolean
  onChange: (value: boolean) => void
  label?: string | JSX.Element
  disabled?: boolean
  isFetching?: boolean
}

export const Checkbox = ({
  value,
  onChange,
  label,
  disabled,
  isFetching,
  className,
  iconClassName,
  labelClassName,
}: CheckboxProps) => {
  return (
    <label
      className={twMerge(
        'flex items-center gap-3',
        disabled ? 'cursor-default' : 'cursor-pointer',
        'group w-fit',
        className,
      )}
      aria-checked={value}
    >
      <div className="flex items-center justify-center">
        <input
          disabled={disabled}
          checked={value}
          className={twMerge(
            'peer/checkbox main-transition-colors',
            disabled
              ? 'cursor-default border-background-tertiary/90 bg-background-tertiary/40 checked:border-text-primary/75 checked:bg-text-primary/70'
              : 'border-text-secondary checked:border-text-primary checked:bg-text-primary',
            isFetching && 'animate-pulse',
            'size-[20px] cursor-pointer appearance-none rounded-md border outline-none ring-brand-primary ring-offset-1 focus-visible:ring-2',
            iconClassName,
          )}
          type="checkbox"
          onChange={e => onChange(e.target.checked)}
        />
        <CheckCheckboxIcon
          className={twMerge(
            'absolute',
            disabled
              ? value
                ? 'fill-background-secondary/70 opacity-100'
                : 'opacity-0'
              : 'fill-background-secondary opacity-100',
          )}
        />
      </div>
      {label && (
        <span
          className={twMerge(
            'main-transition-colors',
            value ? 'text-text-primary' : 'text-text-primary/50',
            'leading-5',
            labelClassName,
          )}
        >
          {label}
        </span>
      )}
    </label>
  )
}
